import axios from '~/util/axios'
import '~/assets/css/snui/index.scss'
import components from '~/components/snui/components'

/** @type {Vue.PluginObject<null>} */
const snui = {
  install (Vue) {
    Vue.mixin({
      components,
      created () {
        // in storybook we don't care to query any server for a theme color. So we'll just set a default
        if (process.env.NODE_ENV === 'development') return this.setAccentColor('#003353')
        this.setAccentColor('#003353')

        // this.getCompanyTheme()
        //   .then((colors) => {
        //     if (!this.isValidHexCode(colors.primary)) return

        //     this.setAccentColor(colors.primary)
        //   })
      },
      methods: {
        setAccentColor (color) {
          document.documentElement.style.setProperty('--accent-color', color)
        },
        getCompanyTheme () {
          return axios.post('/api/v1/custom_ui_theme').then(res => res.data)
        },
        isValidHexCode (hexCode) {
          return /^#[0-9A-F]{6}$/i.test(hexCode)
        }
      }
    })
  }
}

export default snui
